import Head from 'next/head';
import Buttons from '@/components/Buttons';

const ButtonsPage = () => {
  return (
    <>
      <Head>
        <title>Buttons</title>
      </Head>

      <Buttons />
    </>
  );
};

export default ButtonsPage;
